import { Routes, Route } from 'react-router-dom';
import TopBar from './components/TopBar';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Collection from './pages/Collection';
import HoopEmbroidery from './pages/HoopEmbroidery';
import PhotoEmbroidery from './pages/PhotoEmbroidery';
import HandcraftedAccessories from './pages/HandcraftedAccessories';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import About from './pages/About';
import Contact from './pages/Contact';
import FloatingWhatsApp from './components/common/FloatingWhatsApp';
import ProductView from './pages/ProductView';
import Shirts from './pages/handcrafted/Shirts';
import Keychains from './pages/handcrafted/Keychains';
import Hankies from './pages/handcrafted/Hankies';
import GadgetAccessories from './pages/handcrafted/GadgetAccessories';
import Diary from './pages/handcrafted/Diary';

export default function App() {
    return (
        <div className="app-root">
            <ScrollToTop />
            <div className="fixed-header">
                <TopBar />
                <Navbar />
            </div>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/collection" element={<Collection />} />
                <Route path="/photo-embroidery" element={<PhotoEmbroidery />} />
                <Route path="/hoop-embroidery" element={<HoopEmbroidery />} />
                <Route path="/accessories" element={<HandcraftedAccessories />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/product-view" element={<ProductView />} />
                <Route path="/shirts" element={<Shirts />} />
                <Route path="/keychains" element={<Keychains />} />
                <Route path="/hankies" element={<Hankies />} />
                <Route path="/gadget-accessories" element={<GadgetAccessories />} />
                <Route path="/diary" element={<Diary />} />
            </Routes>
            <FloatingWhatsApp />
            <Footer />
        </div >
    );
}